import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { FieldLabel } from '../Field.js';
import { IFormFieldText } from '../Submission/GenericFieldComponents/Text/index.js';
import RichTextSubmission, {
  RichTextField
} from '../Submission/GenericFieldComponents/RichText/RichTextSubmission.js';
import { OutlineCard } from '@morressier/alembic';
interface IFormFieldRichTextProps {
  config: IFormFieldText;
  placeholder?: string;
  isEditingAllowed?: boolean;
}

const FormFieldRichTextInput: React.FC<IFormFieldRichTextProps> = ({ config }) => {
  const { watch } = useFormContext();

  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const value = watch(field) as string;

  return (
     <OutlineCard width="100%" padding={4}>
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        label={labels.main}
        subText={labels.subtitle}
        isRequired={validations.required}
        helpText={labels.helpText}
      />
      <Flex flexDirection="column" width="100%" alignItems="flex-start" gap={2}>
        <RichTextSubmission
          initialValue={value}
          label={labels.main}
          field={field as RichTextField}
        />
      </Flex>
    </Flex>
    </OutlineCard>
  );
};

export default FormFieldRichTextInput;
